module.exports = __webpack_public_path__ + "static/media/no-results.6ed69e27.png";